import WelcomePartial from './WelcomePartial';
import compose from 'recompose/compose';
import { withUser } from '../../../data-providers/user';
import formatPrismicData from '../../../hocs/formatPrismicData';
import withProps from 'recompose/withProps';
import get from 'lodash/get';

const enhance = compose(
  withUser,
  formatPrismicData,
  withProps(props => ({
    firstName: get(props, 'user.firstname', ''),
  }))
);

export default enhance(WelcomePartial);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Account/WelcomePartial/index.js